import { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Detect when user reaches near the bottom of the page (footer visible)
      const scrollPosition = window.innerHeight + window.scrollY;
      const pageHeight = document.body.offsetHeight;
      const threshold = 150; // px before the absolute bottom
      
      setIsVisible(scrollPosition >= pageHeight - threshold);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-6 right-6 z-50 p-3 rounded-full bg-forest-800/90 text-sand-50 shadow-lift hover:bg-forest-700 transition-colors duration-base animate-fade-slide-up hover:animate-none hover:-translate-y-1"
      aria-label="Volver al inicio"
    >
      <ChevronUp className="h-5 w-5 animate-bounce-subtle" />
    </button>
  );
};

export default ScrollToTop;
